(() => {
  'use strict';
  if (window.__damasciBookingTracking) return;
  window.__damasciBookingTracking = true;
  const script = document.currentScript;
  const preview = script?.dataset.preview !== 'false';
  const measurementId = 'G-95XDPCBZHG';
  const routes = {
    '/damasci/toronto': 'Yorkville, Toronto',
    '/damasci/mississauga': 'Mississauga',
    '/damasci/virtual-appointment': 'Virtual Appointment'
  };
  const seen = new Set();
  const storageKey = 'damasci_booking_ids_v1';
  const pendingKey = 'damasci_booking_pending_v1';
  const ttl = 30 * 60 * 1000;
  let initialized = false;
  function permitted() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function read(key, fallback) {
    try { return JSON.parse(sessionStorage.getItem(key)) ?? fallback; }
    catch (_) { return fallback; }
  }
  function write(key, value) {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  }
  function bookingRoute(raw) {
    try {
      const url = new URL(raw, location.href);
      if (url.origin !== 'https://calendly.com') return null;
      const path = url.pathname.replace(/\/+$/, '');
      return routes[path] ? {path, label: routes[path]} : null;
    } catch (_) { return null; }
  }
  function initialize() {
    if (initialized || preview || !permitted()) return;
    const cookies = document.cookie.split(';').map(value => value.trim().split('=')[0]);
    if (!cookies.includes('_ga') || !cookies.includes('_ga_95XDPCBZHG')) return;
    initialized = true;
    window.dataLayer = window.dataLayer || [];
    const tag = function () { window.dataLayer.push(arguments); };
    window.__damasciBookingTag = tag;
    tag('js', new Date());
    tag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false
    });
    const loader = document.createElement('script');
    loader.async = true;
    loader.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
    document.head.appendChild(loader);
  }
  function uuid(value) {
    return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
  }
  function deliver(id, label, method) {
    if (!uuid(id) || !Object.values(routes).includes(label)) return;
    if (!preview && !permitted()) return;
    const key = (preview ? 'preview:' : '') + id;
    if (seen.has(key) || read(storageKey, []).includes(key)) return;
    initialize();
    if (!preview && typeof window.__damasciBookingTag !== 'function') return;
    seen.add(key);
    write(storageKey, [...read(storageKey, []), key].slice(-100));
    const params = {
      send_to: measurementId,
      booking_id: id,
      event_category: 'calendly',
      event_label: label,
      booking_method: method,
      page_location: location.origin + location.pathname
    };
    if (preview) {
      document.dispatchEvent(new CustomEvent('damasci:booking-preview', {detail: {event: 'website_appointment_booked', ...params}}));
    } else {
      window.__damasciBookingTag('event', 'website_appointment_booked', params);
    }
  }
  window.addEventListener('message', event => {
    if (event.origin !== 'https://calendly.com' || !['calendly.date_and_time_selected', 'calendly.event_scheduled'].includes(event.data?.event)) return;
    const frame = Array.from(document.querySelectorAll('iframe')).find(item => item.contentWindow === event.source);
    if (!frame) return;
    const route = bookingRoute(frame.getAttribute('src'));
    if (!route) return;
    if (!preview && !permitted()) return;
    write(pendingKey, {label: route.label, at: Date.now()});
    initialize();
    if (event.data.event !== 'calendly.event_scheduled') return;
    try {
      const invitee = new URL(event.data.payload?.invitee?.uri);
      if (invitee.origin !== 'https://api.calendly.com') return;
      const match = invitee.pathname.match(/^\/scheduled_events\/[^/]+\/invitees\/([^/]+)$/);
      // Let immediate confirmation-page redirects deliver before claiming this booking.
      if (match) window.setTimeout(() => deliver(match[1], route.label, 'embedded'), 1000);
    } catch (_) {}
  });
  document.addEventListener('click', event => {
    const anchor = event.target?.closest?.('a[href]');
    if (!anchor || (!preview && !permitted())) return;
    const route = bookingRoute(anchor.href);
    let hub = false;
    try { const u = new URL(anchor.href); hub = u.origin === 'https://calendly.com' && u.pathname.replace(/\/+$/, '') === '/damasci'; } catch (_) {}
    if (route || hub) write(pendingKey, {label: route?.label || null, at: Date.now()});
  }, true);
  function confirmation() {
    if (location.pathname !== '/pages/appointment-confirmed') return;
    if (!preview && !permitted()) return;
    const pending = read(pendingKey, null);
    if (!pending || Date.now() - pending.at > ttl || Date.now() < pending.at) return;
    const query = new URLSearchParams(location.search);
    const label = query.get('event_type_name');
    if (pending.label && pending.label !== label) return;
    deliver(query.get('invitee_uuid'), label, 'redirect');
  }
  function ready() { initialize(); confirmation(); }
  document.addEventListener('visitorConsentCollected', ready);
  if (window.Shopify?.customerPrivacy) ready();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) ready(); });
  }
  if (preview) confirmation();
})();
